export const createGetNextPageParam = (pageSize = 20) => (lastPage, pages) => {
    if (lastPage.length < (pageSize ? Number(pageSize) : 20)) {
        return;
    }
    return pages.length + 1;
};
export const createGetNextPageParamMetaPages = (key, totalPagesKey, pageSize = 20) => (lastMetaPage, pages) => {
    // Use totalPages metadata if available
    if (lastMetaPage[totalPagesKey] !== undefined &&
        pages.length >= lastMetaPage[totalPagesKey]) {
        return;
    }
    // Otherwise check if the last page is full
    if (lastMetaPage[key].length < (pageSize ? Number(pageSize) : 20)) {
        return;
    }
    return pages.length + 1;
};
//# sourceMappingURL=pagination.js.map